import React from 'react';
import BaseScadaNode from './BaseScadaNode';

export function BoxFormerSVG({ config = {}, width = 90, height = 70, liveValues = {} }) {
    const running = parseFloat(liveValues.state ?? 0) >= parseFloat(config.threshold ?? 0.5);
    const hasError = liveValues.error === 1 || liveValues.error === true ||
        liveValues.error === '1' || liveValues.error === 'true';
    const statusColor = hasError ? '#EF4444' : running ? '#22C55E' : '#64748B';

    const cx = width / 2;
    const cy = height / 2;
    const count = parseInt(liveValues.count ?? 0);

    return (
        <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} style={{ display: 'block' }}>
            {/* Machine body */}
            <rect x={4} y={4} width={width - 8} height={height - 8} rx={4}
                fill="#1E293B" stroke={statusColor} strokeWidth={2} />

            {/* Flat cardboard blank (left side) */}
            <g>
                <rect x={10} y={cy - 10} width={16} height={20} rx={1}
                    fill="none" stroke="#94A3B8" strokeWidth={1.5} strokeDasharray="3 2"
                    opacity={0.7} />
                <line x1={10} y1={cy} x2={26} y2={cy}
                    stroke="#94A3B8" strokeWidth={0.8} opacity={0.5} />
            </g>

            {/* Folding arrows (center) */}
            <g opacity={running ? 1 : 0.4}>
                {/* Top fold arrow */}
                <path d={`M ${cx - 6},${cy - 8} L ${cx + 2},${cy - 3}`}
                    fill="none" stroke={statusColor} strokeWidth={1.5} markerEnd="url(#arrowBF)" />
                {/* Bottom fold arrow */}
                <path d={`M ${cx - 6},${cy + 8} L ${cx + 2},${cy + 3}`}
                    fill="none" stroke={statusColor} strokeWidth={1.5} markerEnd="url(#arrowBF)" />
                {running && (
                    <animate attributeName="opacity" values="1;0.5;1" dur="1s" repeatCount="indefinite" />
                )}
            </g>

            {/* Formed 3D box (right side) */}
            <g transform={`translate(${width - 32}, ${cy - 12})`}>
                {/* Front face */}
                <rect x={0} y={6} width={18} height={16} fill="#334155" stroke={statusColor} strokeWidth={1.5} />
                {/* Top face */}
                <path d="M 0,6 L 6,0 L 24,0 L 18,6 Z" fill="#475569" stroke={statusColor} strokeWidth={1} />
                {/* Right face */}
                <path d="M 18,6 L 24,0 L 24,16 L 18,22 Z" fill="#3B4C63" stroke={statusColor} strokeWidth={1} />
            </g>

            {/* Arrow marker definition */}
            <defs>
                <marker id="arrowBF" markerWidth="6" markerHeight="4" refX="5" refY="2" orient="auto">
                    <path d="M 0,0 L 6,2 L 0,4 Z" fill={statusColor} />
                </marker>
            </defs>

            {/* Count display */}
            {count > 0 && (
                <text x={cx} y={height - 8} textAnchor="middle"
                    fill="#94A3B8" fontSize={9} fontFamily="monospace">
                    {count}
                </text>
            )}

            {/* Error flash */}
            {hasError && (
                <rect x={2} y={2} width={width - 4} height={height - 4} rx={4}
                    fill="none" stroke="#EF4444" strokeWidth={2}>
                    <animate attributeName="stroke-opacity" values="1;0;1" dur="0.6s" repeatCount="indefinite" />
                </rect>
            )}
        </svg>
    );
}

export default function BoxFormerNode(props) {
    const { data } = props;
    const w = data?.width || 90;
    const h = data?.height || 70;
    return (
        <BaseScadaNode {...props}>
            <BoxFormerSVG config={data?.config} width={w} height={h} liveValues={data?.liveValues || {}} />
            {data?.label && (
                <div style={{ textAlign: 'center', fontSize: 10, color: '#94A3B8', marginTop: 2,
                    overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
                    {data.label}
                </div>
            )}
        </BaseScadaNode>
    );
}
